import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import HeadsetInterface from 'resources/headsets/headset-interface';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';
import isElectron from 'is-electron';
var ipcRenderer = isElectron() ? require('electron').ipcRenderer : null;
var Jabra4Headset = /*#__PURE__*/function (_HeadsetInterface) {
  function Jabra4Headset() {
    var _this;
    _classCallCheck(this, Jabra4Headset);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Jabra4Headset, [].concat(args));
    _defineProperty(_this, "attachCallbacks", function (callbacks) {
      _this.callbacks = callbacks(_this.id);
      ipcRenderer.send('jabraAttachCallbacks');
      ipcRenderer.on('jabraDisconnectEvent', _this.callbacks.onDisconnect);
      ipcRenderer.on('jabraMuteEvent', _this.callbacks.onMuteEvent);
      ipcRenderer.on('jabraUnmuteEvent', _this.callbacks.onUnmuteEvent);
      ipcRenderer.on('jabraHoldEvent', _this.callbacks.onHoldCall);
      ipcRenderer.on('jabraUnholdEvent', _this.callbacks.onUnholdCall);
      ipcRenderer.on('jabraAcceptedEvent', _this.callbacks.onAcceptCall);
      ipcRenderer.on('jabraOnHangupEvent', _this.callbacks.onHangup);
      return _this;
    });
    return _this;
  }
  _inherits(Jabra4Headset, _HeadsetInterface);
  return _createClass(Jabra4Headset, [{
    key: "incomingCallImpl",
    value: function () {
      var _incomingCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              addHeadsetLogEntry('Jabra signalIncomingCall');
              ipcRenderer.send('jabraIncomingCall');
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function incomingCallImpl() {
        return _incomingCallImpl.apply(this, arguments);
      }
      return incomingCallImpl;
    }()
  }, {
    key: "outgoingCallImpl",
    value: function () {
      var _outgoingCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              addHeadsetLogEntry('Jabra startCall');
              ipcRenderer.send('jabraOutgoingCall');
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function outgoingCallImpl() {
        return _outgoingCallImpl.apply(this, arguments);
      }
      return outgoingCallImpl;
    }()
  }, {
    key: "confirmCallImpl",
    value: function () {
      var _confirmCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_callId, incoming, answeredThroughHeadset) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!incoming || answeredThroughHeadset)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              ipcRenderer.send('jabraConfirmCall');
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function confirmCallImpl(_x, _x2, _x3) {
        return _confirmCallImpl.apply(this, arguments);
      }
      return confirmCallImpl;
    }()
  }, {
    key: "endCallImpl",
    value: function () {
      var _endCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_callId, hungupThroughHeadset) {
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!hungupThroughHeadset) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              ipcRenderer.send('jabraEndCall');
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function endCallImpl(_x4, _x5) {
        return _endCallImpl.apply(this, arguments);
      }
      return endCallImpl;
    }()
  }, {
    key: "holdCallImpl",
    value: function () {
      var _holdCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              addHeadsetLogEntry('Jabra hold');
              ipcRenderer.send('jabraHoldCall');
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function holdCallImpl() {
        return _holdCallImpl.apply(this, arguments);
      }
      return holdCallImpl;
    }()
  }, {
    key: "resumeCallImpl",
    value: function () {
      var _resumeCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              addHeadsetLogEntry('Jabra resume');
              ipcRenderer.send('jabraResumeCallImpld');
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function resumeCallImpl() {
        return _resumeCallImpl.apply(this, arguments);
      }
      return resumeCallImpl;
    }()
  }, {
    key: "muteCallImpl",
    value: function () {
      var _muteCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              addHeadsetLogEntry('Jabra mute');
              ipcRenderer.send('jabraMuteCall');
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function muteCallImpl() {
        return _muteCallImpl.apply(this, arguments);
      }
      return muteCallImpl;
    }()
  }, {
    key: "unmuteCallImpl",
    value: function () {
      var _unmuteCallImpl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              addHeadsetLogEntry('Jabra unmute');
              ipcRenderer.send('jabraUnmuteCall');
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function unmuteCallImpl() {
        return _unmuteCallImpl.apply(this, arguments);
      }
      return unmuteCallImpl;
    }()
  }, {
    key: "onDisconnectImpl",
    value: function onDisconnectImpl() {
      ipcRenderer.send('jabraDisconnect');
    }
  }]);
}(HeadsetInterface);
export { Jabra4Headset as default };